module.exports = __webpack_public_path__ + "static/media/user-13.005c80e1.jpg";